import { Badge, BadgeProps } from '@chakra-ui/react';
import { UserType, UserTypes } from '../../user.types';

interface PermissionBadgeProps extends BadgeProps {
  permission: UserType;
}

export const PermissionBadge = ({ permission, ...otherProps }: PermissionBadgeProps) => {
  const color = permission === UserTypes.Business ? 'font.500' : 'white';
  const backgroundColor = permission === UserTypes.Business ? 'yellow.500' : 'avatar.3';
  return (
    <Badge
      variant={'solid'}
      color={color}
      backgroundColor={backgroundColor}
      paddingX={2}
      textTransform={'capitalize'}
      minWidth={'min-content'}
      minHeight={5}
      borderRadius={'base'}
      fontWeight={'medium'}
      {...otherProps}
    >
      {permission}
    </Badge>
  );
};
